export const ACTIVOSFIJOS_LISTA = 'PPTCACFILIST'
export const ACTIVOSFIJOS_EDITAR = 'PPTCACFIEDIT'
export const ACTIVOSFIJOS_NUEVO = 'PPTCACFINUEV'
export const ACTIVOSFIJOS_REPORTES = 'PPTCACFIREPO'
export const ACTIVOSFIJOS_BAJAS_LISTA = 'PPTCACFIBAJALIST'
export const ACTIVOSFIJOS_BAJAS_NUEVO = 'PPTCACFIBAJANUEV'
export const ACTIVOSFIJOS_BAJAS_EDITAR = 'PPTCACFIBAJAEDIT'
export const ACTIVOSFIJOS_INVENTARIOS_LISTA = 'PPTCACFIINVLIST'
export const ACTIVOSFIJOS_INVENTARIOS_NUEVO = 'PPTCACFIINVNUEV'
export const ACTIVOSFIJOS_INVENTARIOS_EDITAR = 'PPTCACFIINVEDIT'

export const LIBROSELECTRONICOS_CAJABANCOS = 'PPTCLIELCABA'

export const SOCIOS_LISTA = 'PPTCSOCILIST'
export const SOCIOS_EDITAR = 'PPTCSOCIEDIT'
export const SOCIOS_NUEVO = 'PPTCSOCINUEV'

export const PRESUPUESTOS_REPORTES = 'PPTCPRESUREPO'
export const PRESUPUESTOS_NUEVO = 'PPTCPRESUNUEV'
export const PRESUPUESTOS_LISTA = 'PPTCPRESULIST'


export const PLANCONTABLE_MAIN = 'PPTCPLCOMAIN'
export const PLANCONTABLE_VERMOV = 'PPTCPLCOVERMOV'

export const CENTROSCOSTO_LISTA = 'PPTCCECOLIST'
export const CENTROSCOSTO_REPORTES = 'PPTCCECOREPO'

export const ESTRUCTURASBALANCE_LISTA = 'PPTCESTRUCBALAN'

export const ESTADOSFINANCIEROS_REPORTE = 'PPTCESTAFINANREP'
export const ESTADOSFINANCIEROS_BALANCEGENERAL = 'PPTCESTAFINANBALGEN'
export const ESTADOSFINANCIEROS_BALANCESUNAT_PLEANUAL = 'PPTCESTAFINANBALSUNPLEANU'
export const ESTADOSFINANCIEROS_CIERRECLASE679 = 'PPTCESTAFINANCIERRE679'

export const FACTORESCOSTOSINDIRECTOS_MAIN = 'PPTCFACOINMAIN'

export const BLOQUEOSPERIODOS_MAIN = 'PPTCBLPEMAIN'

export const COMPANIA_MAIN = 'PCTCCOMPMAIN'
export const COMPANIA_NUEVO = 'PCTCCOMPNUEV'

export const FONDOFIJO_REPORTES = 'PCTCFOFIREPO'

export const GLOSASCONTABILIDAD_LISTA = 'PCTCGLCOLIST'

export const MAYORIZACION_MAIN = 'PCTCMAYOMAIN'
export const BACKGROUNDJOBS_MAIN = 'PCTCBGJOMAIN'

export const USUARIOS_NUEVO = 'PCTCUSUANUEV'
export const USUARIOS_LISTA = 'PCTCUSUALIST'

export const ROLES_NUEVO = 'PCTCROLENUEV'
export const ROLES_LISTA = 'PCTCROLELIST'

export const TABLASCOMUNES_MAIN = 'PPTCTACOMAIN'
export const TABLASCOMUNES_UNICO = 'PPTCTACOUNIC'

export const ASIENTOSCONTABLES_LISTA = 'PPTCASCOLIST'
export const ASIENTOSCONTABLES_DETALLES = 'PPTCASCODETA'
export const ASIENTOSCONTABLES_NUEVO = 'PPTCASCONUEV'
export const ASIENTOSCONTABLES_NUEVODIARIO_APLIACIONNOTA = 'PPTCASCONUDIAPNO'
export const ASIENTOSCONTABLES_UTILES = 'PPTCASCOUTI'
export const ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS = 'PPTCASCOCONDOC'
export const ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE = 'PPTCASCOCONCUCO'
export const ASIENTOSCONTABLES_NUEVOOGCANJE = 'PPTCASCONOCJ'
export const ASIENTOSCONTABLES_NUEVOOGCOBR = 'PPTCASCONOCB'
export const ASIENTOSCONTABLESORIGENDIARIO_NUEVO = 'PCTCACODNUEV'
export const ASIENTOSCONTABLES_IMPORTAR = 'PPTCASCOIMPO'
export const ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS = 'PPTCASCOREPORECO'
export const ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS = 'PPTCASCOREPOREVE'
export const ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES = 'PPTCASCOREPOREPRO'
export const ASIENTOSCONTABLES_REPORTES_DETRACCIONES = 'PPTCASCOREPODET'
export const ASIENTOSCONTABLES_REPORTES_LIBRODIARIO = 'PPTCASCOREPOLIDI'
export const ASIENTOSCONTABLES_REPORTES_LIBROMAYOR = 'PPTCASCOREPOLIMA'
export const ASIENTOSCONTABLES_REPORTES_LIBROANEXOS = 'PPTCASCOREPOLIAN'
export const ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR = 'PPTCASCOREPOLIAUX'
export const ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS = 'PPTCASCOREPOLICB'
export const ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION = 'PPTCASCOREPOBACU'
export const ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL = 'PPTCASCOREPOBAGE'
export const ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE = 'PPTCASCOREPOANBA'
export const ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS = 'PPTCASCOREPOCONSIS'
export const ASIENTOSCONTABLES_SIRE_REPORTES = 'PPTCASCOSIREREPO'

export const ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS = 'PPTCASCOLIELRECO'
export const ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS = 'PPTCASCOLIELREVE'
export const ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO = 'PPTCASCOLIELLIBDIAR'
export const ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR = 'PPTCASCOLIELLIBMAY'
export const ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE = 'PPTCASCOLIELRVIE'

export const PLANTILLASCONTABILIDAD_LISTA = 'PCTCPTLCLIST'
export const PLANTILLASCONTABILIDAD_NUEVO = 'PCTCPTLCNUEV'

export const PLANTILLASGENERALESCONTABILIDAD_LISTA = 'PCTCPLGCLIST'
export const PLANTILLASGENERALESCONTABILIDAD_NUEVO = 'PCTCPLGCNUEV'
export const PLANTILLASGENERALESCONTABILIDAD_EDITAR = 'PCTCPLGCEDIT'

export const ASIENTOSCONTABLES_NODOMICILIADOS = 'PPTCASCONODOMIC'

export const PRESUPUESTOS_MAIN = 'PPTCPRESMAIN'
export const PRESUPUESTOS_ASIGNACION = 'PPTCPRESASIG'

export const PROYECTOS_LISTA = 'PPTCPROYLIST'

export const SELF_PERFIL = 'PPTCSELFPERF'

export const CAJACHICA_TRABAJADOR_VIATICO = 'PPTCCACHTRVI'
export const CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES = 'PPTCCACHASDOTRA'
export const CAJACHICA_ASIGNAR_DOCUMENTOS = 'PPTCCACHASDO'
export const CAJACHICA_REGISTRAR_TRABAJADORES_LISTA = 'PPTCCACHRETRLIST'
export const CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO = 'PPTCCACHRETRNUEV'

export const COMPUTER_MAIN = 'COMPUTER_MAIN'

export const __dictionary = {
  [PROYECTOS_LISTA]: {
    id: PROYECTOS_LISTA,
    nombre: 'PROYECTOS_LISTA'
  },
  [PRESUPUESTOS_ASIGNACION]: {
    id: PRESUPUESTOS_ASIGNACION,
    nombre: 'PRESUPUESTOS_ASIGNACION'
  },
  [PRESUPUESTOS_MAIN]: {
    id: PRESUPUESTOS_MAIN,
    nombre: 'PRESUPUESTOS_MAIN'
  },
  [PRESUPUESTOS_NUEVO]: {
    id: PRESUPUESTOS_NUEVO,
    nombre: 'PRESUPUESTOS_NUEVO'
  },
  [PRESUPUESTOS_LISTA]: {
    id: PRESUPUESTOS_LISTA,
    nombre: 'PRESUPUESTOS_LISTA'
  },
  [PRESUPUESTOS_REPORTES]: {
    id: PRESUPUESTOS_REPORTES,
    nombre: 'PRESUPUESTOS_REPORTES'
  },
  [CAJACHICA_ASIGNAR_DOCUMENTOS]: {
    id: CAJACHICA_ASIGNAR_DOCUMENTOS,
    nombre: 'CAJACHICA_ASIGNAR_DOCUMENTOS'
  },
  [ESTADOSFINANCIEROS_CIERRECLASE679]: {
    id: ESTADOSFINANCIEROS_CIERRECLASE679,
    nombre: 'ESTADOSFINANCIEROS_CIERRECLASE679'
  },
  [LIBROSELECTRONICOS_CAJABANCOS]: {
    id: LIBROSELECTRONICOS_CAJABANCOS,
    nombre: 'LIBROSELECTRONICOS_CAJABANCOS'
  },
  [CAJACHICA_TRABAJADOR_VIATICO]: {
    id: CAJACHICA_TRABAJADOR_VIATICO,
    nombre: 'CAJACHICA_TRABAJADOR_VIATICO'
  },
  [CAJACHICA_ASIGNAR_DOCUMENTOS]: {
    id: CAJACHICA_ASIGNAR_DOCUMENTOS,
    nombre: 'CAJACHICA_ASIGNAR_DOCUMENTOS'
  },
  [CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES]: {
    id: CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES,
    nombre: 'CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES'
  },
  [CAJACHICA_REGISTRAR_TRABAJADORES_LISTA]: {
    id: CAJACHICA_REGISTRAR_TRABAJADORES_LISTA,
    nombre: 'CAJACHICA_REGISTRAR_TRABAJADORES_LISTA'
  },
  [CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO]: {
    id: CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO,
    nombre: 'CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO'
  },
  [ESTADOSFINANCIEROS_BALANCEGENERAL]: {
    id: ESTADOSFINANCIEROS_BALANCEGENERAL,
    nombre: 'ESTADOSFINANCIEROS_BALANCEGENERAL'
  },
  [SELF_PERFIL]: { id: SELF_PERFIL, nombre: 'SELF_PERFIL' },
  [ASIENTOSCONTABLES_NODOMICILIADOS]: {
    id: ASIENTOSCONTABLES_NODOMICILIADOS,
    nombre: 'ASIENTOSCONTABLES_NODOMICILIADOS'
  },
  [ACTIVOSFIJOS_LISTA]: { id: ACTIVOSFIJOS_LISTA, nombre: 'ACTIVOSFIJOS_LISTA' },
  [ACTIVOSFIJOS_EDITAR]: { id: ACTIVOSFIJOS_EDITAR, nombre: 'ACTIVOSFIJOS_EDITAR' },
  [ACTIVOSFIJOS_NUEVO]: { id: ACTIVOSFIJOS_NUEVO, nombre: 'ACTIVOSFIJOS_NUEVO' },
  [ACTIVOSFIJOS_REPORTES]: { id: ACTIVOSFIJOS_REPORTES, nombre: 'ACTIVOSFIJOS_REPORTES' },
  [ACTIVOSFIJOS_BAJAS_LISTA]: { id: ACTIVOSFIJOS_BAJAS_LISTA, nombre: 'ACTIVOSFIJOS_BAJAS_LISTA' },
  [ACTIVOSFIJOS_BAJAS_NUEVO]: { id: ACTIVOSFIJOS_BAJAS_NUEVO, nombre: 'ACTIVOSFIJOS_BAJAS_NUEVO' },
  [ACTIVOSFIJOS_BAJAS_EDITAR]: { id: ACTIVOSFIJOS_BAJAS_EDITAR, nombre: 'ACTIVOSFIJOS_BAJAS_EDITAR' },
  [ACTIVOSFIJOS_INVENTARIOS_LISTA]: { id: ACTIVOSFIJOS_INVENTARIOS_LISTA, nombre: 'ACTIVOSFIJOS_INVENTARIOS_LISTA' },
  [ACTIVOSFIJOS_INVENTARIOS_NUEVO]: { id: ACTIVOSFIJOS_INVENTARIOS_NUEVO, nombre: 'ACTIVOSFIJOS_INVENTARIOS_NUEVO' },
  [ACTIVOSFIJOS_INVENTARIOS_EDITAR]: { id: ACTIVOSFIJOS_INVENTARIOS_EDITAR, nombre: 'ACTIVOSFIJOS_INVENTARIOS_EDITAR' },
  [PLANCONTABLE_MAIN]: { id: PLANCONTABLE_MAIN, nombre: 'PLANCONTABLE_MAIN' },
  [PLANCONTABLE_VERMOV]: { id: PLANCONTABLE_VERMOV, nombre: 'PLANCONTABLE_VERMOV' },
  [CENTROSCOSTO_LISTA]: { id: CENTROSCOSTO_LISTA, nombre: 'CENTROSCOSTO_LISTA' },
  [CENTROSCOSTO_REPORTES]: { id: CENTROSCOSTO_REPORTES, nombre: 'CENTROSCOSTO_REPORTES' },
  [ESTRUCTURASBALANCE_LISTA]: { id: ESTRUCTURASBALANCE_LISTA, nombre: 'ESTRUCTURASBALANCE_LISTA' },
  [ESTADOSFINANCIEROS_REPORTE]: { id: ESTADOSFINANCIEROS_REPORTE, nombre: 'ESTADOSFINANCIEROS_REPORTE' },
  [FACTORESCOSTOSINDIRECTOS_MAIN]: { id: FACTORESCOSTOSINDIRECTOS_MAIN, nombre: 'FACTORESCOSTOSINDIRECTOS_MAIN' },
  [BLOQUEOSPERIODOS_MAIN]: { id: BLOQUEOSPERIODOS_MAIN, nombre: 'BLOQUEOSPERIODOS_MAIN' },
  [COMPANIA_MAIN]: { id: COMPANIA_MAIN, nombre: 'COMPANIA_MAIN' },
  [COMPANIA_NUEVO]: { id: COMPANIA_NUEVO, nombre: 'COMPANIA_NUEVO' },
  [FONDOFIJO_REPORTES]: { id: FONDOFIJO_REPORTES, nombre: 'FONDOFIJO_REPORTES' },
  [GLOSASCONTABILIDAD_LISTA]: { id: GLOSASCONTABILIDAD_LISTA, nombre: 'GLOSASCONTABILIDAD_LISTA' },
  [MAYORIZACION_MAIN]: { id: MAYORIZACION_MAIN, nombre: 'MAYORIZACION_MAIN' },
  [BACKGROUNDJOBS_MAIN]: { id: BACKGROUNDJOBS_MAIN, nombre: 'BACKGROUNDJOBS_MAIN' },
  [USUARIOS_NUEVO]: { id: USUARIOS_NUEVO, nombre: 'USUARIOS_NUEVO' },
  [USUARIOS_LISTA]: { id: USUARIOS_LISTA, nombre: 'USUARIOS_LISTA' },
  [ROLES_NUEVO]: { id: ROLES_NUEVO, nombre: 'ROLES_NUEVO' },
  [ROLES_LISTA]: { id: ROLES_LISTA, nombre: 'ROLES_LISTA' },
  [TABLASCOMUNES_MAIN]: { id: TABLASCOMUNES_MAIN, nombre: 'TABLASCOMUNES_MAIN' },
  [TABLASCOMUNES_UNICO]: { id: TABLASCOMUNES_UNICO, nombre: 'TABLASCOMUNES_UNICO' },
  [ASIENTOSCONTABLES_LISTA]: { id: ASIENTOSCONTABLES_LISTA, nombre: 'ASIENTOSCONTABLES_LISTA' },
  [ASIENTOSCONTABLES_SIRE_REPORTES]: { id: ASIENTOSCONTABLES_SIRE_REPORTES, nombre: 'ASIENTOSCONTABLES_SIRE_REPORTES' },
  [ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE]: { id: ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE, nombre: 'ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE' },
  [ASIENTOSCONTABLES_DETALLES]: { id: ASIENTOSCONTABLES_DETALLES, nombre: 'ASIENTOSCONTABLES_DETALLES' },
  [ASIENTOSCONTABLES_NUEVO]: { id: ASIENTOSCONTABLES_NUEVO, nombre: 'ASIENTOSCONTABLES_NUEVO' },
  [ASIENTOSCONTABLES_UTILES]: { id: ASIENTOSCONTABLES_UTILES, nombre: 'ASIENTOSCONTABLES_UTILES' },
  [ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS]: {
    id: ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS,
    nombre: 'ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS'
  },
  [ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE]: {
    id: ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE,
    nombre: 'ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE'
  },
  [ASIENTOSCONTABLES_NUEVOOGCANJE]: { id: ASIENTOSCONTABLES_NUEVOOGCANJE, nombre: 'ASIENTOSCONTABLES_NUEVOOGCANJE' },
  [ASIENTOSCONTABLES_NUEVOOGCOBR]: { id: ASIENTOSCONTABLES_NUEVOOGCOBR, nombre: 'ASIENTOSCONTABLES_NUEVOOGCOBR' },
  [ASIENTOSCONTABLESORIGENDIARIO_NUEVO]: {
    id: ASIENTOSCONTABLESORIGENDIARIO_NUEVO,
    nombre: 'ASIENTOSCONTABLESORIGENDIARIO_NUEVO'
  },
  [ASIENTOSCONTABLES_IMPORTAR]: { id: ASIENTOSCONTABLES_IMPORTAR, nombre: 'ASIENTOSCONTABLES_IMPORTAR' },
  [ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS]: {
    id: ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS,
    nombre: 'ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS'
  },
  [ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS]: {
    id: ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS,
    nombre: 'ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS'
  },
  [ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES]: {
    id: ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES,
    nombre: 'ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES'
  },
  [ASIENTOSCONTABLES_REPORTES_DETRACCIONES]: {
    id: ASIENTOSCONTABLES_REPORTES_DETRACCIONES,
    nombre: 'ASIENTOSCONTABLES_REPORTES_DETRACCIONES'
  },
  [ASIENTOSCONTABLES_REPORTES_LIBRODIARIO]: {
    id: ASIENTOSCONTABLES_REPORTES_LIBRODIARIO,
    nombre: 'ASIENTOSCONTABLES_REPORTES_LIBRODIARIO'
  },
  [ASIENTOSCONTABLES_REPORTES_LIBROMAYOR]: {
    id: ASIENTOSCONTABLES_REPORTES_LIBROMAYOR,
    nombre: 'ASIENTOSCONTABLES_REPORTES_LIBROMAYOR'
  },
  [ASIENTOSCONTABLES_REPORTES_LIBROANEXOS]: {
    id: ASIENTOSCONTABLES_REPORTES_LIBROANEXOS,
    nombre: 'ASIENTOSCONTABLES_REPORTES_LIBROANEXOS'
  },
  [ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR]: {
    id: ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR,
    nombre: 'ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR'
  },
  [ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS]: {
    id: ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS,
    nombre: 'ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS'
  },
  [ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION]: {
    id: ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION,
    nombre: 'ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION'
  },
  [ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL]: {
    id: ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL,
    nombre: 'ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL'
  },
  [ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE]: {
    id: ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE,
    nombre: 'ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE'
  },
  [ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS]: {
    id: ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS,
    nombre: 'ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS'
  },
  [ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS]: {
    id: ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS,
    nombre: 'ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS'
  },
  [ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS]: {
    id: ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS,
    nombre: 'ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS'
  },
  [ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO]: {
    id: ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO,
    nombre: 'ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO'
  },
  [ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR]: {
    id: ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR,
    nombre: 'ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR'
  },
  [PLANTILLASCONTABILIDAD_LISTA]: { id: PLANTILLASCONTABILIDAD_LISTA, nombre: 'PLANTILLASCONTABILIDAD_LISTA' },
  [PLANTILLASCONTABILIDAD_NUEVO]: { id: PLANTILLASCONTABILIDAD_NUEVO, nombre: 'PLANTILLASCONTABILIDAD_NUEVO' },
  [PLANTILLASGENERALESCONTABILIDAD_LISTA]: {
    id: PLANTILLASGENERALESCONTABILIDAD_LISTA,
    nombre: 'PLANTILLASGENERALESCONTABILIDAD_LISTA'
  },
  [PLANTILLASGENERALESCONTABILIDAD_NUEVO]: {
    id: PLANTILLASGENERALESCONTABILIDAD_NUEVO,
    nombre: 'PLANTILLASGENERALESCONTABILIDAD_NUEVO'
  },
  [PLANTILLASGENERALESCONTABILIDAD_EDITAR]: {
    id: PLANTILLASGENERALESCONTABILIDAD_EDITAR,
    nombre: 'PLANTILLASGENERALESCONTABILIDAD_EDITAR'
  }
}

export const __array = [
  PROYECTOS_LISTA,
  PRESUPUESTOS_ASIGNACION,
  PRESUPUESTOS_MAIN,
  PRESUPUESTOS_NUEVO,
  PRESUPUESTOS_LISTA,
  PRESUPUESTOS_REPORTES,
  CAJACHICA_ASIGNAR_DOCUMENTOS,
  CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES,
  CAJACHICA_TRABAJADOR_VIATICO,
  CAJACHICA_REGISTRAR_TRABAJADORES_LISTA,
  CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO,
  ASIENTOSCONTABLES_NODOMICILIADOS,
  ACTIVOSFIJOS_LISTA,
  ACTIVOSFIJOS_EDITAR,
  ACTIVOSFIJOS_NUEVO,
  ACTIVOSFIJOS_REPORTES,
  ACTIVOSFIJOS_BAJAS_LISTA,
  ACTIVOSFIJOS_BAJAS_NUEVO,
  ACTIVOSFIJOS_BAJAS_EDITAR,
  ACTIVOSFIJOS_INVENTARIOS_LISTA,
  ACTIVOSFIJOS_INVENTARIOS_NUEVO,
  ACTIVOSFIJOS_INVENTARIOS_EDITAR,
  PLANCONTABLE_MAIN,
  PLANCONTABLE_VERMOV,
  CENTROSCOSTO_LISTA,
  CENTROSCOSTO_REPORTES,
  ESTADOSFINANCIEROS_CIERRECLASE679,
  ESTRUCTURASBALANCE_LISTA,
  ESTADOSFINANCIEROS_REPORTE,
  FACTORESCOSTOSINDIRECTOS_MAIN,
  BLOQUEOSPERIODOS_MAIN,
  COMPANIA_MAIN,
  COMPANIA_NUEVO,
  FONDOFIJO_REPORTES,
  GLOSASCONTABILIDAD_LISTA,
  MAYORIZACION_MAIN,
  BACKGROUNDJOBS_MAIN,
  USUARIOS_NUEVO,
  USUARIOS_LISTA,
  ROLES_NUEVO,
  ROLES_LISTA,
  TABLASCOMUNES_MAIN,
  TABLASCOMUNES_UNICO,
  ASIENTOSCONTABLES_LISTA,
  ASIENTOSCONTABLES_SIRE_REPORTES,
  ASIENTOSCONTABLES_DETALLES,
  ASIENTOSCONTABLES_NUEVO,
  ASIENTOSCONTABLES_UTILES,
  ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS,
  ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE,
  ASIENTOSCONTABLES_NUEVOOGCANJE,
  ASIENTOSCONTABLES_NUEVOOGCOBR,
  ASIENTOSCONTABLESORIGENDIARIO_NUEVO,
  ASIENTOSCONTABLES_IMPORTAR,
  ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS,
  ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS,
  ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES,
  ASIENTOSCONTABLES_REPORTES_DETRACCIONES,
  ASIENTOSCONTABLES_REPORTES_LIBRODIARIO,
  ASIENTOSCONTABLES_REPORTES_LIBROMAYOR,
  ASIENTOSCONTABLES_REPORTES_LIBROANEXOS,
  ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR,
  ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS,
  ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION,
  ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL,
  ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE,
  ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS,
  ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS,
  ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS,
  ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO,
  ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR,
  ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE,
  PLANTILLASCONTABILIDAD_LISTA,
  PLANTILLASCONTABILIDAD_NUEVO,
  PLANTILLASGENERALESCONTABILIDAD_LISTA,
  PLANTILLASGENERALESCONTABILIDAD_NUEVO,
  PLANTILLASGENERALESCONTABILIDAD_EDITAR,
  SELF_PERFIL,
  ESTADOSFINANCIEROS_BALANCEGENERAL,
  LIBROSELECTRONICOS_CAJABANCOS
]
